export default "__VITE_ASSET__CD4bRVz2__"